import { string } from "../types/string";

export default function toLowerCase(a) {
  return string(a).toLowerCase();
}
